import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CarouselMain from "./components/CarouselMain";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ImgStart from "./components/ImgStart";
import Bot from "./components/Bot";
import Promo from "./components/Promo";
import AutoGasPromo from "./components/AutoGasPromo";
//import Galery from "./components/Galery";

function App() {
  return (
    <div>
      <Header />
      <Promo />
      <CarouselMain />
      <ImgStart />
      <Carousel />
      <Call />
      <PorqueElegirnos />
      <Services />
      <AutoGasPromo />
      <Footer />
      <Bot />
    </div>
  );
}

export default App;
